module.exports = __webpack_public_path__ + "static/cacador-296681e598fca62a73159dba21fce084.svg";